import React from 'react';
import PropTypes from 'prop-types';
import styles from './Toast.module.css';
import classNames from "classnames";

export const Toast = ({
 message = '',
 type = 'success',
 onClose,
}) => {

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const getStyles = (type) => {
    switch (type) {
      case 'success':
        return styles.toastSuccess;
      case 'error':
        return styles.toastError;
      case 'warning':
        return styles.toastWarning;
      case 'info':
        return styles.toastInfo;
      default:
        return styles.toastSuccess;
    }
  }

  return (
    <div className={classNames(styles.toast, getStyles(type))}>
      <div className='toast-content'>{message}</div>
      <button className={styles.toastClose} onClick={handleClose}>
        &#x2715;
      </button>
    </div>
  );
};

Toast.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  duration: PropTypes.number,
  onClose: PropTypes.func,
  isVisible: PropTypes.bool,
};